import { useUmpiresContext } from "../../../contexts/Umpires";
import { SortColumns } from "../types/umpires";

export const setSortingClassNames = (colName: SortColumns) => {
    const { sortColumn, sortOrder } = useUmpiresContext();

    switch (true) {
        case sortColumn === colName && sortOrder === "ascending":
            return "sorting_asc";
        case sortColumn === colName && sortOrder === "descending":
            return "sorting_desc";
        default:
            return "";
    }
};
